import { render, staticRenderFns } from "./DemandTabLinks.vue?vue&type=template&id=54bba550"
import script from "./DemandTabLinks.vue?vue&type=script&lang=js"
export * from "./DemandTabLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports